import { render, staticRenderFns } from "./ViewEquipmentTransferPage.vue?vue&type=template&id=68d9d2e0"
import script from "./ViewEquipmentTransferPage.vue?vue&type=script&lang=js"
export * from "./ViewEquipmentTransferPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports